<div
  (click)="onCardClick($event)"
  (keydown.enter)="onCardClick($event)"
  (keydown.space)="onCardClick($event)"
  class="card-basic {{ cssClass() }}"
  [ngClass]="{ 'card-clickable': !disabled() }"
  tabindex="0"
  role="button"
  [attr.aria-label]="(ariaLabel() | translate) || null"
  data-test="basic-card-clickable"
>
  <div class="card-basic-body">
    <div class="row">
      <div class="col mw-0">
        <ng-content />
      </div>
      @if (!disabled()) {
        <div class="col-auto d-flex align-items-center">
          <i class="fas fa-chevron-right text-black"></i>
        </div>
      }
    </div>
  </div>
</div>
